import { alertsConstants } from '../_constants';

export function alerts(
  state = { fetchingDetail: false, detail: {} },
  action
) {
  switch (action.type) {
    case alertsConstants.DETAIL_REQUEST:
      return {
        ...state,
        fetchingDetail: true
      };
    case alertsConstants.DETAIL_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail
      };
    case alertsConstants.DETAIL_FAILURE:
      return {};
    case alertsConstants.FEEDBACK_REQUEST:
      return {
        ...state
      };
    case alertsConstants.FEEDBACK_SUCCESS:
      const newItem = state.detail.reduce((array, item) => {
        if (item.id === action.detail.id) {
          item = action.detail
        }
        return array.concat(item);
      }, [])
      return {
        ...state,
        detail: newItem
      };
    case alertsConstants.FEEDBACK_FAILURE:
      return {
        ...state
      };
    case alertsConstants.CORRECT_REQUEST:
      return {
        ...state
      };
    case alertsConstants.CORRECT_SUCCESS:
      let newDetail = [];
      if(Array.isArray(state.detail)) {
         newDetail = state.detail.reduce((array, item) => {
          if (item.id === action.detail.id) {
            item = action.detail
          }
          return array.concat(item);
        }, [])
      } else if ('detail' in action) {
        window.location.reload();
      }
      return {
        ...state,
        detail: newDetail
      };
    case alertsConstants.CORRECT_FAILURE:
      return {
        ...state
      };
    default:
      return state;
  }
}
